import React from 'react';

// Loading skeleton mirroring the prerendered static shell's structure
// (PaperDetails wrapper + ScoreCard grid + Card) so hydration swaps are
// styled-to-styled with no layout flash.
const Bar = ({ className }) => (
  <div className={`bg-gray-200 rounded animate-pulse ${className || ''}`} />
);

const ScoreSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 mb-6">
    <Bar className="h-5 w-1/2 mb-2" />
    <Bar className="h-8 w-1/3 mb-2" />
    <Bar className="h-4 w-full" />
  </div>
);

const PaperSkeleton = () => (
  <div className="w-full" aria-busy="true">
    <div className="mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex justify-between items-center mb-8">
        <Bar className="h-8 w-2/3" />
      </div>
      <div className="bg-gray-100 rounded-lg shadow-md p-8">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-6 w-full">
          <ScoreSkeleton />
          <ScoreSkeleton />
          <ScoreSkeleton />
          <ScoreSkeleton />
        </div>
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <Bar className="h-6 w-1/4 mb-4" />
          <Bar className="h-4 w-full mb-2" />
          <Bar className="h-4 w-5/6 mb-2" />
          <Bar className="h-4 w-4/6" />
        </div>
      </div>
    </div>
  </div>
);

export default PaperSkeleton;
